<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="height: 100%;overflow: auto;padding-bottom: 53px;">

    <!-- <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right">
          <a-button @click="toggleScreen" icon="appstore" style="height:20px;width:20px;border:0px"></a-button>
        </span>
      </div>

    </template> -->

    <a-spin :spinning="confirmLoading">
      <a-form :form="tenantForm">

        <a-form-item label="租户名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入租户名称" :maxLength="200" v-decorator.trim="['name', validatorRules.name]"/>
        </a-form-item>        

        <a-form-item label="联系人" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input placeholder="请输入联系人" :maxLength="20" v-decorator.trim="['contacts',validatorRules.requiredCommon]" />
        </a-form-item>

        <a-form-item label="手机号码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入手机号码" :maxLength="20" v-decorator.trim="['phone',validatorRules.phone]" :readOnly="!!model.id"/>
        </a-form-item>

        <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入邮箱" :maxLength="20" v-decorator.trim="['email',validatorRules.email]" :readOnly="!!model.id"/>
        </a-form-item>

        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="[ 'status', validatorRules.requiredCommon]" placeholder="请选择状态" :getPopupContainer= "(target) => target.parentNode">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">停用</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            placeholder="请选择开始时间"
            showTime format="YYYY-MM-DD HH:mm:ss"
            v-decorator="['beginTime_formatText', {initialValue:!model.beginTime_formatText?null:moment(model.beginTime_formatText,dateFormat),rules: [{ required: true, message: '请输入内容!' }]}]"
            :getCalendarContainer="node => node.parentNode" />
        </a-form-item>

        <a-form-item label="截止时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            placeholder="请选择截止时间"
            showTime format="YYYY-MM-DD HH:mm:ss"
            v-decorator="['endTime_formatText', {initialValue:!model.endTime_formatText?null:moment(model.endTime_formatText,dateFormat),rules: [{ required: true, message: '请输入内容!' }]}]"
            :getCalendarContainer="node => node.parentNode"/>
        </a-form-item>

        <a-form-item label="限制队列数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number placeholder="请输入限制队列数量" v-decorator="['projectLimit',validatorRules.requiredCommon]" :min="0" :precision="0" style="width: 100%"/>
        </a-form-item>

        <a-form-item label="限制中心数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number placeholder="请输入限制中心数量" v-decorator="['centerLimit',validatorRules.requiredCommon]" :min="0" :precision="0" style="width: 100%"/>
        </a-form-item>

        <a-form-item label="机构名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入机构名称" :maxLength="200" v-decorator.trim="['orgName', validatorRules.requiredCommon]"/>
        </a-form-item>

        <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea :rows="3" placeholder="请输入地址" :maxLength="200" v-decorator.trim="['address',{}]" />
        </a-form-item>

      </a-form>
    </a-spin>

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm title="确定放弃编辑？" @confirm="handleCancel" okText="确定" cancelText="取消">
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
  import pick from 'lodash.pick'
  import moment from 'moment'
  import Vue from 'vue'
  // 引入搜索部门弹出框的组件
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getAction } from '@/api/manage'
  import {addTenant,editTenant } from '@/api/api'
  import { disabledAuthFilter } from "@/utils/authFilter"
  import {duplicateCheck } from '@/api/api'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  export default {
    name: "TenantModal",
    components: {
      
    },
    data () {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        modalWidth:800,
        drawerWidth:700,
        modaltoggleFlag:true,
        id:"", //id
        disableSubmit:false,
        dateFormat:"YYYY-MM-DD HH:mm:ss",
        validatorRules:{
          name:{
            rules: [{
              required: true, message: '请输入租户名称!'
            },{
              validator: this.validateName,
            }]
          },
          requiredCommon:{rules: [{ required: true, message: '请输入内容!' }]},
          phone:{rules: [{required: true, message: '请输入内容!'},{ validator: this.validatePhone}]},
          email:{
            rules: [{required: true, message: '请输入内容!'},{validator: this.validateEmail}],
          },          
        },
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,        
        tenantForm:this.$form.createForm(this),
      }
    },
    created () {
    },
    computed:{
    },
    methods: {
      //窗口最大化切换
      toggleScreen(){
        if(this.modaltoggleFlag){
          this.modalWidth = window.innerWidth;
        }else{
          this.modalWidth = 800;
        }
        this.modaltoggleFlag = !this.modaltoggleFlag;
      },
      add(){
        this.edit({});
      },
      edit(record){
        this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
        let that = this;
        that.checkedDepartNameString = "";
        that.tenantForm.resetFields();
        
        that.id = record.id;
        that.visible = true;
        that.model = Object.assign({}, record);
        that.$nextTick(() => {
          that.tenantForm.setFieldsValue(pick(this.model,'name','contacts','phone','status','projectLimit','centerLimit','address','email','orgName'))
        });
      },      
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
      },
      moment,
      handleSubmit () {
        const that = this;        
        
        // 触发表单验证
        this.tenantForm.validateFields((err, values) => {
          console.log("handleSubmit..." + err)
          if (!err) {
            that.confirmLoading = true;
            if(!values.beginTime_formatText){
              values.beginTime = '';
            }else{
              values.beginTime = values.beginTime_formatText.format(this.dateFormat);
            }
            if(!values.endTime_formatText){
              values.endTime = '';
            }else{
              values.endTime = values.endTime_formatText.format(this.dateFormat);
            }
            let formData = Object.assign(this.model, values);
                        
            let obj;
            if(!this.model.id){
              formData.id = this.id;
              obj=addTenant(formData);
            }else{
              obj=editTenant(formData);
            }
            obj.then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      validatePhone(rule, value, callback){
        if(!value){
          callback()
        }else{
          //update-begin--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
          if(new RegExp(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/).test(value)){
            var params = {
              tableName: 'sys_tenant',
              fieldName: 'phone',
              fieldVal: value,
              dataId: this.id
            };
            console.log("validatePhone.dataId:" + this.id)
            duplicateCheck(params).then((res) => {
              if (res.success) {
                callback()
              } else {
                callback("电话号码已存在!")
              }
            })
          }else{
            callback("请输入正确格式的手机号码!");
          }
        }
      },
      validateEmail(rule, value, callback){
        if(!value){
          callback()
        }else{
          if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
            var params = {
              tableName: 'sys_tenant',
              fieldName: 'email',
              fieldVal: value,
              dataId: this.id
            };
            duplicateCheck(params).then((res) => {
              console.log(res)
              if (res.success) {
                callback()
              } else {
                callback("邮箱已存在!")
              }
            })
          }else{
            callback("请输入正确格式的邮箱!")
          }
        }
      },
      validateName(rule, value, callback){
        var params = {
          tableName: 'sys_tenant',
          fieldName: 'name',
          fieldVal: value,
          dataId: this.id
        };
        console.log("validateName.dataId:" + this.id)
        duplicateCheck(params).then((res) => {
          if (res.success) {
          callback()
        } else {
          callback("租户名称已存在!")
        }
      })
      },
      // 根据屏幕变化,设置抽屉尺寸
      resetScreenSize(){
        let screenWidth = document.body.clientWidth;
        if(screenWidth < 500){
          this.drawerWidth = screenWidth;
        }else{
          this.drawerWidth = 700;
        }
      }
    }
  }
</script>

<style scoped>
  .avatar-uploader > .ant-upload {
    width:104px;
    height:104px;
  }
  .ant-upload-select-picture-card i {
    font-size: 49px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .ant-table-tbody .ant-table-row td{
    padding-top:10px;
    padding-bottom:10px;
  }

  .drawer-bootom-button {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>
